import { render } from "./AssignmentCancel.vue?vue&type=template&id=51376a02&scoped=true&ts=true"
import script from "./AssignmentCancel.vue?vue&type=script&lang=ts"
export * from "./AssignmentCancel.vue?vue&type=script&lang=ts"

import "./AssignmentCancel.vue?vue&type=style&index=0&id=51376a02&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51376a02"]])

export default __exports__